import { useState, useEffect, useRef, MutableRefObject } from 'react';
import {
  Button,
  ButtonSet,
  Slider,
  NumberInput,
  Tooltip,
  Accordion,
  AccordionItem,
} from 'carbon-components-react';

import { FormattedMessage, useIntl } from 'react-intl';
import messages from '../locales/messages';
import Cookies from 'js-cookie';
import Helmet from 'react-helmet';

import './APIConnectBvaEstimator.scss';
import 'src/common/style/importantStyle.scss';
import 'src/common/style/common.scss';
import countryList from '../services/currencies.json';
import { segmentTracking } from '../lib/tracker';
import Thanks from './Thanks/Thanks';
import { useEnv } from 'src/common/hooks/widgets/useEnv';
import { useBPName } from 'src/common/hooks/widgets/useBPName';
import { useCookiesURL } from 'src/common/hooks/widgets/useCookiesURL';
import { usePrice } from '../hooks/usePrice';
import { useSmallBreakpoint } from 'src/common/hooks/widgets/useBreakpoint';
import {
  useCurrency,
  removeSymbol,
} from 'src/common/hooks/widgets/useCurrency';
import {
  UT30Databand,
  Max_Number_Full_Employees,
  Min_Number_Full_Employees,
  Max_Time_Percentage_Development,
  Min_Time_Percentage_Development,
  Max_Hours_Worked_Yearly,
  Max_Avg_Burden_Cost_Yearly,
  Min_Hours_Worked_Yearly,
  Min_Avg_Burden_Cost_Yearly,
} from '../constants/spread'; // 5000
import { swapCountryAndLanguage } from 'src/common/utils/swapCountryAndLanguage';
import { IBMLocale } from 'src/common/locale/mapValidLocale';
import * as URX_FORM from '../constants/urx-form';
import {
  LangDefaults,
  determineCountry,
  useLang,
} from 'src/common/hooks/widgets/useLang';
import { initUrxForm } from 'src/common/hooks/widgets/urxForm';
import {
  urxScript,
  urxScriptLoader,
} from 'src/common/hooks/widgets/globalDefinitions';
import BusinessPartner from 'src/common/components/BusinessPartner/BusinessPartner';
import { FormModal } from 'src/common/utils/FormModal';
import { getParamsFromUrl } from 'src/common/utils/getParamsFromUrl';
export interface APIConnectBvaEstimatorProps {
  langCode: string;
  test: boolean;
  countryToTest: string;
}

const APIConnectBvaEstimator = ({
  langCode,
  test,
  countryToTest,
}: APIConnectBvaEstimatorProps) => {
  const localeCode = swapCountryAndLanguage(langCode as IBMLocale);
  const [currency, setCurrency] = useState('');
  const [, setCountry] = useState('');
  const hoursWorkedRef = useRef() as MutableRefObject<HTMLInputElement>;
  const avgBurdenRef = useRef() as MutableRefObject<HTMLInputElement>;
  // lang and userlocale is based out of ddo
  const [lang, userLocale] = useLang(
    countryList,
    test,
    countryToTest,
    setCurrency,
    setCountry,
    localeCode,
  );
  /* Have urx form deault in us-en when on language us page */
  const [urxlang] = useState(localeCode.toString());
  const [localCurrency, setlocalCurrency] = useState<string>(localeCode);

  useEffect(() => {
    setlocalCurrency(userLocale); // show local Currency
  }, [userLocale, localeCode, localCurrency]);
  const [environment] = useEnv();
  const [, setToggleCountry] = useState(false);
  const [, setModalLocalCountry] = useState('');
  const [, setModalLocalCurrency] = useState('USD');
  const [, setModalLocalLanguage] = useState('English');

  useEffect(() => {
    setlocalCurrency(userLocale); // show local Currency
  }, [userLocale, localeCode, localCurrency]);

  const [, setLocalExist] = useState(false);
  let localStorageFound = localStorage.getItem('langLocale');
  if (localStorageFound == null)
    localStorageFound = LangDefaults.localCountryLang;
  const [, setSelectedLocale] = useState(localStorageFound);
  const intl = useIntl();

  // Determine Country
  determineCountry(
    setLocalExist,
    setSelectedLocale,
    setModalLocalCountry,
    setModalLocalLanguage,
    setModalLocalCurrency,
    setToggleCountry,
    lang,
    countryList,
    true,
    test,
    localeCode,
  );

  const [hoursWorkedPerEmp, setHoursWorkedPerEmp] = useState(1920);
  const [avgBurdenCostYearly, setAvgBurdenCostYearly] = useState(134398);
  const [invalidHoursWorkedYearly, setInvalidHoursWorkedYearly] =
    useState(false);
  const [invalidaAvgBurdenCost, setInvalidAvgBurdenCost] = useState(false);
  const [invalidNumberFullEmployees, setInvalidNumberFullEmployees] =
    useState(false);
  const [invalidPercentageDevTime, setInvalidPercentageDevTime] =
    useState(false);
  const [numberEmployees, setNumberEmployees] = useState(3);
  const [percentageDevelopmentTime, setPercentageDevelopmentTime] =
    useState(50);
  const [hoursSaving, setHoursSaving] = useCurrency(currency, userLocale, 100);
  const [yearlySaving, setYearlySaving] = useCurrency(currency, userLocale, 0);

  const [formComplete, setFormComplete] = useState(false);
  const [drawerOpen, setDrawerOpen] = useState(false);

  const isSmall = useSmallBreakpoint('560px');
  const { bpName, logo, companyId, desc, mssp } = useBPName(UT30Databand, true);
  const cookieURL = useCookiesURL();
  const [countDownPassed, setCountDownPassed] = useState(false);

  usePrice({
    numberFullTimeEmployee: numberEmployees,
    timeSpentPerDeveloper: percentageDevelopmentTime,
    hoursWorkedYearly: hoursWorkedPerEmp,
    avgBurdenCost: avgBurdenCostYearly,
    setHoursSaving,
    setYearlySaving,
  });

  useEffect(() => {
    setTimeout(() => {
      setCountDownPassed(!countDownPassed);
    }, 1000);
  }, []);

  window.urxEnvironment = environment;
  window.onUrxFormSubmitSuccess = () => {
    setFormComplete(!formComplete);
  };

  // for one mob detachment
  const code = getParamsFromUrl('code');

  useEffect(() => {
    setCookie();
  }, [
    numberEmployees,
    percentageDevelopmentTime,
    hoursWorkedPerEmp,
    avgBurdenCostYearly,
    hoursSaving,
    yearlySaving,
  ]);

  const setCookie = () => {
    Cookies.set(
      'urxdcq',
      JSON.stringify({
        source: URX_FORM.FORM_ID,
        // One field to provide all values (stringify)
        dcq: {
          Q_NOTESDATA:
            cookieURL +
            ' Number of employee doing API:' +
            numberEmployees +
            ' | % time engrs spend developing API:' +
            percentageDevelopmentTime +
            ' |  hours worked per emp yearly:' +
            hoursWorkedPerEmp +
            ' | avg burden cost per employee:' +
            avgBurdenCostYearly +
            ' | Hours saved yearly: ' +
            hoursSaving +
            ' | Estimated yearly saving:' +
            yearlySaving +
            (getBp() ? `|Preferred BP:${getBp()}` : ''),
          Q_ASSET_URL: window.location.href, // ISC - Asset URL initial
          Q_ASSET_NAME: 'API Connect BVA Estiamtor', // ISC - Asset Name
        },
      }),
    );
  };

  const getBp = () => {
    if (bpName) return bpName;
    if (logo) return companyId;
    if (desc) return desc;
    if (mssp) return mssp;

    const bpField = document.querySelector('#Q_BPNAME') as HTMLInputElement;
    return bpField ? bpField.value : '';
  };

  const handleSliders = (
    value: number,
    setValue: React.Dispatch<React.SetStateAction<number>>,
    max: number,
    setMaxMin: React.Dispatch<React.SetStateAction<boolean>>,
  ) => {
    if (value >= 1 && value <= max) {
      setValue(value);
      setMaxMin(false);
    } else if (value >= max) {
      setValue(max);
      setMaxMin(true);
    } else {
      setValue(1);
      setMaxMin(true);
    }
  };

  return (
    <div className="api-connect-bva widget-styles">
      <Helmet>
        <script src={urxScript}></script>
        <script src={urxScriptLoader}></script>
      </Helmet>
      {formComplete ? (
        <Thanks
          numberEmployee={numberEmployees}
          percentageDevTime={percentageDevelopmentTime}
          hoursWorked={hoursWorkedPerEmp}
          avgBurdenCost={avgBurdenCostYearly}
          hoursSaving={hoursSaving}
          yearlySaving={yearlySaving}
        />
      ) : (
        <div className="bx--grid" id="api-connect-bva-grid">
          {bpName ? (
            <BusinessPartner bpName={bpName} logo={logo} desc={desc} />
          ) : null}
          <div className="bx--row mar3">
            {/* Main content div */}
            <div className="bx--col-lg-9 bx--col-md-16 bx--col-sm-4">
              {/* Starting heading */}
              <div className="bx--row">
                <div className="bx--col-lg-16 bx--col-md-16 bx--col-sm-16">
                  <p className="page_sub_heading">
                    <FormattedMessage {...messages.welcome_msg_1} />
                  </p>
                </div>
              </div>
              {/* Paragraph */}
              <div className="bx--row mar3">
                <div className="bx--col-lg-16 bx--col-md-16 bx--col-sm-16">
                  <p className="subheading">
                    <FormattedMessage {...messages.scoping_text} />
                  </p>
                </div>
              </div>
              {/* Slider for number of employees developing API */}
              <div className="bx--row mar3">
                <div className="bx--col-lg-16 bx--col-md-16 bx--col-sm-16">
                  <p className="page_body">
                    <FormattedMessage {...messages.triggertext_NFED} />
                  </p>
                </div>
              </div>
              <div className="bx--row">
                <div className="bx--col-lg-16 bx--col-md-16 bx--col-sm-16">
                  <Slider
                    id="NFED"
                    min={Min_Number_Full_Employees}
                    max={Max_Number_Full_Employees}
                    value={numberEmployees}
                    onBlur={() => {
                      null;
                    }}
                    invalid={invalidNumberFullEmployees}
                    labelText={
                      invalidNumberFullEmployees ? (
                        <span className="slide_text">
                          <FormattedMessage {...messages.invalidNFED} />
                        </span>
                      ) : null
                    }
                    onChange={({ value }) => {
                      segmentTracking('CTA Clicked', {
                        pageTitle: 'API Connect BVA',
                        object: 'API Connect BVA page',
                        resultValue: 'CTA clicked',
                        CTA: 'NFED Slider',
                        location: 'Assessment',
                        action: '',
                        field: '',
                      });
                      handleSliders(
                        value,
                        setNumberEmployees,
                        Max_Number_Full_Employees,
                        setInvalidNumberFullEmployees,
                      );
                    }}
                  />
                </div>
              </div>
              {/* Slider % time spent per employee doing API with tooltip*/}
              <div className="bx--row mar3">
                <div className="bx--col-lg-16 bx--col-md-16 bx--col-sm-16">
                  <label className="page_body">
                    <FormattedMessage {...messages.triggertext_PED} />
                  </label>
                  <Tooltip
                    onChange={() => {
                      segmentTracking('CTA Clicked', {
                        pageTitle: 'API Connect BVA Page',
                        object: 'API Connect BVA page',
                        resultValue: 'CTA clicked',
                        CTA: 'PED tooltip',
                        location: 'Assessment',
                        action: '',
                        field: '',
                      });
                    }}
                    direction={isSmall ? 'bottom' : 'right'}
                    tabIndex={0}
                  >
                    <span className="slide_text">
                      <FormattedMessage {...messages.tooltip_PED} />
                    </span>
                  </Tooltip>
                </div>
              </div>
              <div className="bx--row">
                <div className="bx--col-lg-16 bx--col-md-16 bx--col-sm-16">
                  <Slider //% time spent per employee doing API
                    id="PTED"
                    min={Min_Time_Percentage_Development}
                    max={Max_Time_Percentage_Development}
                    value={percentageDevelopmentTime}
                    step={10}
                    onBlur={() => {
                      null;
                    }}
                    invalid={invalidPercentageDevTime}
                    labelText={
                      invalidPercentageDevTime ? (
                        <span className="slide_text">
                          <FormattedMessage {...messages.invalidTextPED} />
                        </span>
                      ) : null
                    }
                    onChange={({ value }) => {
                      segmentTracking('CTA Clicked', {
                        pageTitle: 'API Connect BVA Page',
                        object: 'API Connect BVA page',
                        resultValue: 'CTA clicked',
                        CTA: 'PTED Slider',
                        location: 'Assessment',
                        action: '',
                        field: '',
                      });
                      handleSliders(
                        value,
                        setPercentageDevelopmentTime,
                        Max_Time_Percentage_Development,
                        setInvalidPercentageDevTime,
                      );
                    }}
                  />
                </div>
              </div>
              {/* Advanced section */}
              <div className="bx--row">
                <div className="bx--col-lg-16 bx--col-md-16 bx--col-sm-16">
                  <div className="expandable-tile-1">
                    <Accordion>
                      <AccordionItem
                        title={<FormattedMessage {...messages.tile_tittle} />}
                      >
                        <div className="bx--row mar10">
                          <div className="bx--col-lg-16 bx--col-md-16 bx--col-sm-16">
                            <label className="page_body">
                              <FormattedMessage {...messages.tile_head_1} />
                            </label>
                            <Tooltip
                              onChange={() => {
                                segmentTracking('CTA Clicked', {
                                  pageTitle: 'API Connect BVA Page',
                                  object: 'API Connect BVA page',
                                  resultValue: 'CTA clicked',
                                  CTA: 'Percentage of time spent doing API development per employee tooltip',
                                  location: 'Assessment',
                                  action: '',
                                  field: '',
                                });
                              }}
                              direction={isSmall ? 'bottom' : 'right'}
                              tabIndex={0}
                            >
                              <span className="slide_text">
                                <FormattedMessage
                                  {...messages.tooltip_tile_head_1}
                                />
                              </span>
                            </Tooltip>
                          </div>
                        </div>
                        <div className="bx--row">
                          <div className="bx--col-lg-16 bx--col-md-16 bx--col-sm-16">
                            <NumberInput //Hours worked per employee per year
                              id="hoursWorked"
                              size="md"
                              allowEmpty={false}
                              ref={hoursWorkedRef}
                              className="number-input"
                              invalid={invalidHoursWorkedYearly}
                              invalidText={
                                invalidHoursWorkedYearly ? (
                                  <span className="slide_text">
                                    <FormattedMessage
                                      {...messages.invalidTextHoursWorked}
                                    />
                                  </span>
                                ) : null
                              }
                              max={Max_Hours_Worked_Yearly}
                              min={Min_Hours_Worked_Yearly}
                              value={hoursWorkedPerEmp}
                              onChange={() => {
                                segmentTracking('CTA Clicked', {
                                  pageTitle: 'API Connect BVA Page',
                                  object: 'API Connect BVA page',
                                  resultValue: 'CTA clicked',
                                  CTA: 'Number of hours worked per employee per year',
                                  location: 'Assessment',
                                  action: '',
                                  field: '',
                                });
                                handleSliders(
                                  Number(hoursWorkedRef.current.value),
                                  setHoursWorkedPerEmp,
                                  Max_Hours_Worked_Yearly,
                                  setInvalidHoursWorkedYearly,
                                );
                              }}
                            />
                          </div>
                        </div>
                        <div className="bx--row mar10">
                          <div className="bx--col-lg-16 bx--col-md-16 bx--col-sm-16">
                            <label className="page_body">
                              <FormattedMessage {...messages.tile_head_2} />
                            </label>
                            <Tooltip
                              onChange={() => {
                                segmentTracking('CTA Clicked', {
                                  pageTitle: 'API Connect BVA Page',
                                  object: 'API Connect BVA page',
                                  resultValue: 'CTA clicked',
                                  CTA: 'Numbers of hours worked per employee per year tooltip',
                                  location: 'Assessment',
                                  action: '',
                                  field: '',
                                });
                              }}
                              direction={isSmall ? 'bottom' : 'right'}
                              tabIndex={0}
                            >
                              <span className="slide_text">
                                <FormattedMessage
                                  {...messages.tooltip_tile_head_2}
                                />
                              </span>
                            </Tooltip>
                          </div>
                        </div>
                        <div className="bx--row">
                          <div className="bx--col-lg-16 bx--col-md-16 bx--col-sm-16">
                            <NumberInput //Average Burden Cost
                              id="avgBurdenCost"
                              size="md"
                              allowEmpty={false}
                              ref={avgBurdenRef}
                              className="number-input"
                              invalid={invalidaAvgBurdenCost}
                              invalidText={
                                invalidaAvgBurdenCost ? (
                                  <span className="slide_text">
                                    <FormattedMessage
                                      {...messages.invalidTextAvgBurdenCost}
                                    />
                                  </span>
                                ) : null
                              }
                              max={Max_Avg_Burden_Cost_Yearly}
                              min={Min_Avg_Burden_Cost_Yearly}
                              value={avgBurdenCostYearly}
                              onChange={() => {
                                segmentTracking('CTA Clicked', {
                                  pageTitle: 'API Connect BVA Page',
                                  object: 'API Connect BVA page',
                                  resultValue: 'CTA clicked',
                                  CTA: 'Average burden cost of above employees in USD',
                                  location: 'Assessment',
                                  action: '',
                                  field: '',
                                });
                                handleSliders(
                                  Number(avgBurdenRef.current.value),
                                  setAvgBurdenCostYearly,
                                  Max_Avg_Burden_Cost_Yearly,
                                  setInvalidAvgBurdenCost,
                                );
                              }}
                            />
                          </div>
                        </div>
                      </AccordionItem>
                    </Accordion>
                  </div>
                  <div id="footnote" className="div-only-lg">
                    <div className="bx--row">
                      <div className="bx--col-lg-16">
                        <div className="footnote_text">
                          <FormattedMessage {...messages.footnote_one} />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            {/* Separator div */}
            <div className="bx--col-lg-2 bx--col-md-16 bx--col-sm-16"></div>
            {/* Pricing/Greybox div */}
            <div className="bx--col-lg-5 bx--col-md-16 bx--col-sm-16 summary-section">
              <div className="bx--row">
                <div className="bx--col-lg-16 bx--col-md-16 bx--col-sm-16 summary-pricing">
                  {/* Table Header */}
                  <div className="bx--row">
                    <div className="bx--col-lg-10 bx--col-md-16 bx--col-sm-2">
                      <p className="page_body bold">
                        <FormattedMessage {...messages.title_savings_1} />
                      </p>
                    </div>
                    <div className="bx--col-lg-4 bx--col-md-16 bx--col-sm-2">
                      <p className="page_body bold slide-left">
                        <FormattedMessage {...messages.title_savings_2} />
                      </p>
                    </div>
                  </div>
                  {/* pricing table */}
                  <div className="bx--row">
                    <div className="bx--col-lg-16 bx--col-md-16 bx--col-sm-16">
                      <hr className="api-connect__gray-hr" />
                    </div>
                  </div>
                  <div className="bx--row">
                    <div className="bx--col-lg-10 bx--col-md-16 bx--col-sm-2">
                      <p className="price_table_comp__requirement price_table_comp_color">
                        <FormattedMessage {...messages.hours_saved_year} />
                      </p>
                    </div>
                    <div className="bx--col-lg-4 bx--col-md-16 bx--col-sm-2">
                      <p className="page_body_2 slide-left">
                        {removeSymbol(currency, hoursSaving)}{' '}
                        <FormattedMessage {...messages.hours_saving_sufix} />
                      </p>
                    </div>
                  </div>
                  <div className="bx--row">
                    <div className="bx--col-lg-16 bx--col-md-16 bx--col-sm-16">
                      <hr className="api-connect__gray-hr" />
                    </div>
                  </div>
                  <div className="bx--row">
                    <div className="bx--col-lg-10 bx--col-md-16 bx--col-sm-2">
                      <p className="price_table_comp__requirement price_table_comp_color">
                        <FormattedMessage {...messages.yearly_savings} />
                      </p>
                    </div>
                    <div className="bx--col-lg-4 bx--col-md-16 bx--col-sm-2">
                      <p className="page_body_2 slide-left">
                        <FormattedMessage {...messages.saving_prefix} />
                        {removeSymbol(currency, yearlySaving)}
                      </p>
                    </div>
                  </div>
                  <div className="bx--row">
                    <div className="bx--col-lg-16 bx--col-md-16 bx--col-sm-16">
                      <hr className="api-connect__gray-hr" />
                    </div>
                  </div>
                  {/* Button section */}
                  <div className="bx--row">
                    <div className="bx--col-lg-16 bx--col-md-16 bx--col-sm-16">
                      <ButtonSet
                        className="APIConnect-BVA__stack-button"
                        stacked
                      >
                        <Button
                          onClick={() => {
                            segmentTracking('CTA Clicked', {
                              pageTitle: 'API Connect BVA Page',
                              object: 'Pricing page',
                              resultValue: 'CTA clicked',
                              CTA: 'API Connect BVA tile',
                              location: 'Assessment',
                              action: '',
                              field: '',
                            });
                            setCookie();
                            if (code === 'standalone') {
                              initUrxForm(
                                environment,
                                URX_FORM.INSTANCE_ID,
                                URX_FORM.FORM_ID,
                                urxlang as IBMLocale,
                                companyId,
                              );
                              setDrawerOpen(true);
                            } else {
                              localStorage.setItem('showForm', 'true');
                            }
                          }}
                        >
                          <FormattedMessage {...messages.request_a_quote} />
                        </Button>
                      </ButtonSet>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            {/* Form Modal*/}
            <div>
              {code === 'standalone' ? (
                <FormModal
                  pageTitle="API Connect BVA Page"
                  object="API Connect BVA Page"
                  productTitle={'API Connect BVA'}
                  pageUrl={''}
                  location={'Assessment'}
                  bpName={bpName}
                  logo={logo}
                  drawerOpen={drawerOpen}
                  setDrawerOpen={setDrawerOpen}
                  formId={URX_FORM.FORM_ID}
                  lang={lang}
                ></FormModal>
              ) : null}
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default APIConnectBvaEstimator;
